module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state-selector"
  }, [_c('a', {
    staticClass: "button is-small is-danger",
    class: {
      'is-outlined': this.selected !== 1
    },
    on: {
      "click": function($event) {
        _vm.updateState(1)
      }
    }
  }, [_vm._v("Rascunho")]), _vm._v(" "), _c('a', {
    staticClass: "button is-small is-warning",
    class: {
      'is-outlined': this.selected !== 2
    },
    on: {
      "click": function($event) {
        _vm.updateState(2)
      }
    }
  }, [_vm._v("Pendente")]), _vm._v(" "), _c('a', {
    staticClass: "button is-small is-success",
    class: {
      'is-outlined': this.selected !== 3
    },
    on: {
      "click": function($event) {
        _vm.updateState(3)
      }
    }
  }, [_vm._v("Publicado")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af1db4e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Util/StateSelector.vue
// module id = 349
// module chunks = 1